import { defineComponent as _defineComponent } from 'vue'
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';
import { computed, watch } from 'vue';
import { useTradeState } from '../..';
import { useOnBehalfOf } from 'ah-common-lib/src/onBehalfOf/useInjectedOBO';


export default /*#__PURE__*/_defineComponent({
  __name: 'WalletCollateralText',
  props: {
    currency: { default: '' }
  },
  setup(__props: any) {

const props = __props as { currency: string };



const onBehalfOfClient = useOnBehalfOf();

const tradeState = useTradeState();

const wallet = computed(() => {
  return tradeState.store
    .useWalletsStore()
    .getWallet(
      props.currency,
      onBehalfOfClient.value ? { isPartner: false, id: onBehalfOfClient.value.id } : undefined
    );
});

const collateralBalance = computed(() => wallet.value?.collateralBalance ?? 0);

watch(
  () => props.currency,
  () => {
    tradeState.store.useWalletsStore().loadCurrencyWallet({
      currency: props.currency,
      force: true,
      owner: onBehalfOfClient.value ? { isPartner: false, id: onBehalfOfClient.value.id } : undefined,
    });
  },
  { immediate: true }
);

return { __sfc: true,props, onBehalfOfClient, tradeState, wallet, collateralBalance, formatCurrencyValue }
}

})